import React, { useState } from "react";
import { getAvailableChannelVariablesChannelsBySteps } from "@dots-projects/types";
import { ChannelSelector } from "../common";
import { FormLabel } from "./FormLabel";
import { TriggerForEditor, TriggerStepCreate } from "@dots-projects/types";
import { useTriggerEditorStateDispatch } from "./TriggerEditor";
import { useGuildChannels } from "./SendStepFormWithCommonParts";
import { Spin } from "antd";

// Channel selector for the trigger editor
function TriggerEditorChannelSelector({
  readOnly,
  field,
  trigger,
  onlyCustomChannels = false,
  label,
  showRefreshButton = false,
}: {
  readOnly: boolean;
  field: any;
  errorSelect: boolean;
  trigger: TriggerForEditor;
  step?: TriggerStepCreate;
  onlyCustomChannels?: boolean;
  label?: string;
  showRefreshButton?: boolean;
}) {
  const [errorSelect, setErrorSelect] = useState(
    field.value === undefined
      ? false
      : ["Select channel", "$channelId", ""].includes(field.value || "")
  );
  const { dispatch } = useTriggerEditorStateDispatch();

  const availableChannels = getAvailableChannelVariablesChannelsBySteps(
    trigger.isDraft
      ? { ...trigger, type: trigger.liveTriggerConfigs.type }
      : trigger
  );
  const { state } = useTriggerEditorStateDispatch();
  const guildChannels = useGuildChannels(state.trigger.current.communityId);

  // all channels
  const selectableChannels = onlyCustomChannels
    ? availableChannels
    : [
        ...availableChannels,
        ...(guildChannels.data?.map((c) => {
          return { id: c["discord_id"], name: c.name };
        }) || []),
      ];

  return (
    <div data-editor-channel-selector>
      <FormLabel label={label ?? "Where to send?"}>
        {guildChannels.isLoading ? (
          <Spin />
        ) : (
          <ChannelSelector
            readOnly={readOnly}
            platform="discord"
            showTitle={false}
            customStyles={
              errorSelect
                ? {
                    marginLeft: "0",
                    width: "100%",
                    color: "#e53935",
                  }
                : {
                    marginLeft: "0",
                    width: "100%",
                  }
            }
            handleChannelSelection={(channelId: string) => {
              field.onChange(channelId);
              setErrorSelect(false);
            }}
            customChannels={selectableChannels}
            defaultOption={errorSelect ? -1 : field.value}
            errorOptionString="Select channel"
            onlyCustomChannels={true} // hack: had to do this so that ChannelSelector would respect channels pulled and invalidated from the useQuery hook
            showRefreshButton={showRefreshButton}
          />
        )}
      </FormLabel>
    </div>
  );
}

export default TriggerEditorChannelSelector;
